import { formatMoney as format } from 'accounting';

export default function formatMoney(amount) {
  return format(amount, '$', 0, '.', ',');
}
